import { useGLTF } from '@react-three/drei';

function Map() {
  const { nodes, materials } = useGLTF('/models/MapaK.gltf');
  return (
    <group dispose={null}>
      <mesh geometry={nodes.Cubo.geometry} material={materials['Material.001']} position={[18.15, 1.08, 0.91]} rotation={[Math.PI, 0, 0]} scale={[6, 5, 6]} />
      <mesh geometry={nodes.Cubo001.geometry} material={materials['Material.003']} position={[-15.13, 1.04, 5.04]} scale={[6, 12, 5]} />
      <mesh geometry={nodes.Cubo005.geometry} material={materials['Material.006']} position={[46.48, 1.14, -16.63]} rotation={[-Math.PI / 2, 0, -Math.PI / 2]} scale={[6, 3.5, 5]} />
      <mesh
        geometry={nodes.Cubo003.geometry}
        material={materials.Material}
        position={[0.85, 1.07, -14.38]}
        scale={[11.55, 4, 5.6]}
      />
      <mesh geometry={nodes.Cubo006.geometry} material={materials['Material.007']} position={[14.42, 1.12, -8.84]} scale={[4, 4, 4.25]} />
      <mesh geometry={nodes.Cubo002.geometry} material={materials['Material.009']} position={[-14.95, 1.04, -29.74]} scale={[6, 12, 5]} />
    </group>
  );
}

useGLTF.preload('/models/MapaK.gltf');

export default Map;
